'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'

export default function QuickReplyBar({ threadId, isLocked, currentUserStatus }: { threadId: string, isLocked: boolean, currentUserStatus: string }) {
  const [content, setContent] = useState('')
  const [loading, setLoading] = useState(false)
  const router = useRouter()

  if (isLocked || currentUserStatus === 'BANNED') return null

  const handleQuickSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!content.trim() || loading) return

    setLoading(true)
    try {
      const res = await fetch('/api/posts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ threadId, content })
      })

      if (res.ok) {
        setContent('')
        router.refresh()
      }
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-slate-950/90 backdrop-blur-xl border-t border-slate-800/60 p-3 md:p-4 z-40 shadow-[0_-10px_40px_rgba(0,0,0,0.3)]">
      <div className="max-w-4xl mx-auto">
        <form 
          onSubmit={handleQuickSubmit} 
          className="flex items-center gap-2 md:gap-3 bg-slate-900/50 border border-slate-800 rounded-2xl px-3 py-2 md:px-4 shadow-inner focus-within:border-indigo-500/50 focus-within:ring-1 focus-within:ring-indigo-500/50 focus-within:bg-slate-900/80 transition-all group"
        >
          
          {/* CLI Prefix indicator */}
          <span className="hidden sm:flex text-indigo-500/70 group-focus-within:text-indigo-400 font-mono font-bold text-lg leading-none shrink-0 transition-colors">
            ❯
          </span>

          <input 
            type="text"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Type a quick reply..."
            className="flex-1 bg-transparent text-slate-100 placeholder:text-slate-500 text-sm focus:outline-none px-1 md:px-2"
          />

          <div className="flex items-center gap-2 shrink-0">
            {/* Desktop shortcut hint */}
            <span className="hidden md:flex items-center justify-center px-2 py-1 text-[10px] font-mono font-bold text-slate-500 bg-slate-800/80 border border-slate-700 rounded transition-opacity group-focus-within:opacity-0 pointer-events-none">
              ↵ Enter
            </span>
            
            <button
              type="submit"
              disabled={loading || !content.trim()}
              className="h-8 md:h-9 px-3 md:px-4 rounded-xl bg-indigo-500/10 hover:bg-indigo-500/20 disabled:bg-slate-800/50 text-indigo-400 disabled:text-slate-500 font-bold text-xs flex items-center justify-center transition-all border border-indigo-500/20 disabled:border-transparent"
            >
              {loading ? '...' : 'Send'}
            </button>
          </div>

        </form>
      </div>
    </div>
  )
}